import createHomePickupCommand from './createHomePickupCommand';
import getCarrierLabelDocument from './getCarrierLabelDocument';
import getCarrierLabelsInfosQuery from './getCarrierLabelsInfosQuery';
import getCarrierLabelUrlQuery from './getCarrierLabelUrlQuery';
import getCarrierProductByIdQuery from './getCarrierProductByIdQuery';
import getHomePickupScheduleQuery from './getHomePickupScheduleQuery';
import { getPickupPointByGeoCoordQuery } from './getPickupPointByGeoCoordQuery/getPickupPointByGeoCoordQuery';
import { getTransportPlanByIdQuery } from './getTransportPlanByIdQuery';
import setCarrierLabelDownloadedCommand from './setCarrierLabelDownloadedCommand';

const CommonCarrierService = {
  getHomePickupScheduleQuery,
  getCarrierProductByIdQuery,
  createHomePickupCommand,
  getPickupPointByGeoCoordQuery,
  getTransportPlanByIdQuery,
  setCarrierLabelDownloadedCommand,
  getCarrierLabelsInfosQuery,
  getCarrierLabelUrlQuery,
  getCarrierLabelDocument,
};

export default CommonCarrierService;
